<template>
  <div class="p-4 md:p-16">
    <n-card :embedded="true">
      <h1 class="text-center">{{ t('info.voice.title') }}</h1>
      <div class="flex flex-col md:flex-row">
        <div class="md:w-2/3">
          <p>
            {{ t('info.voice.intro') }}
          </p>
          <h2>{{ t('info.features') }}</h2>
          <p>
            {{ t('info.voice.features') }}
          </p>
          <h3>{{ t('info.voice.featuresTitle2') }}</h3>
          <p>
            {{ t('info.voice.features2') }}
          </p>
          <h2>{{ t('info.applications') }}</h2>
          <p>
            {{ t('info.voice.applications') }}
          </p>
          <h2>{{ t('info.playAsYouGo') }}</h2>
          <p>
            {{ t('info.voice.playAsYouGo') }}
          </p>
          <h2>{{ t('info.go') }}</h2>
          <p>
            {{ t('info.voice.go') }}
          </p>
          <div class="mt-4">
            <RouterLink
              :to="{
                name: userStore.isLoggedIn() ? 'voiceGenerator' : 'start',
              }"
            >
              <n-button type="primary">
                {{
                  userStore.isLoggedIn() ? t('home.use') : t('home.try')
                }}
              </n-button>
            </RouterLink>
          </div>
        </div>
        <div class="md:w-1/3 flex flex-col items-center">
          <img class="w-full max-w-[500px]" src="@/assets/images/voice.webp" />
        </div>
      </div>
    </n-card>
  </div>
</template>

<script setup lang="ts">
import { NButton, NCard } from 'naive-ui'
import { useUserStore } from '@/stores/UserStore'
import { useI18n } from 'vue-i18n'
import { useMeta } from '@/composables/Meta'
import { computed } from 'vue'

const { t } = useI18n()
const userStore = useUserStore()
const { updateMetaData } = useMeta()

updateMetaData({
  title: computed(() => t('info.voice.seoTitle')),
  description: computed(() => t('info.voice.seoDescription')),
})
</script>
